export async function streamToText(
  data: ReadableStream<Uint8Array> | null,
  onChunkReceived: (chunk: string) => void,
) {
  if (!data) {
    throw new Error('Body of response is empty')
  }

  const reader = data.getReader()
  const decoder = new TextDecoder()
  let done = false

  while (!done) {
    const { value, done: doneReading } = await reader.read()
    done = doneReading
    const chunkValue = decoder.decode(value)
    onChunkReceived(chunkValue)
  }
}
